/**
 * ROI Minimal calculator (Kirby snippet `roi-minimal`).
 *
 * Self-contained and instance-scoped: initialises every `.roi-calculator-snippet`
 * on the page independently, so the block can appear more than once without the
 * duplicate ids interfering.
 *
 * Kept deliberately decoupled from the big ROI calculator (ptrentability.js /
 * ptpricing.js): all field ids are mroi_*-prefixed.
 */
(function () {
	"use strict";

	/**
	 * Adding the functionality of ROIMinimal on top of the passed DOM Node
	 * @param root a DOM Node, should be a ".roi-calculator-snippet"
	 * @constructor
	 */
	function RoiMinimal(root) {
		var priceCalcRoiMinimal = undefined;
		var rentabilityCalculatorMinimal = undefined;

		// input
		var toCheckbox = el('#mroi_to');
		var rpCheckbox = el('#mroi_rp');
		var mgmtContainer = el('#mroi_usersManagementContainer');
		var usersManagementInput = el('#mroi_usersManagement');
		var usersFieldInput = el('#mroi_usersField');
		var industryInput = el('#mroi_industry');

		// output
		var resultElem = el('#roi-result-value');

		// keep the result links in sync
		var submitBtn = el('#roi-submit');
		var submitBigBtn = el('#roi-submit-big');

		if (root.dataset.roiMinimalInit) {
			return;
		}
		root.dataset.roiMinimalInit = '1';

		// Register update handler
		jQuery(document).on('ptShopCurrencyLoaded.ptpricing', ptShopCurrencyLoadedUpdatePricingMinimal);
		const pricingInitialized = ptShopCurrencyLoadedUpdatePricingMinimal();
		if (!pricingInitialized) {
			// this is the first access of prices, load them
			ptStartShopCurrencyLoad();
		}

		/**
		 * Initialize priceCalcRoiMinimal and rentabilityCalculatorMinimal, as the currency and country may have changed.
		 * Triggerred
		 * - Event ptShopCurrencyLoaded.ptpricing triggered
		 * - initially, maybe the pricing is already loaded
		 * @return true, when it is initialized
		 */
		function ptShopCurrencyLoadedUpdatePricingMinimal()  {
			if (window?.ptShop?.prices) {
				// prices are available, initialize the calculator
				if (priceCalcRoiMinimal === undefined) {
					// only initialize once. PriceCalculator.update reads ptShop.prices live
					priceCalcRoiMinimal = new PriceCalculator();
				}
				if (rentabilityCalculatorMinimal === undefined) {
					// only initialize once
					rentabilityCalculatorMinimal = new RentabilityCalculator(priceCalcRoiMinimal);
				}

				// define the function to read input from gui to rentability calculator
				rentabilityCalculatorMinimal.readInput = function (rc) {
					if (rc !== rentabilityCalculatorMinimal) {
						ptClientErrorLog({
							message: 'rentabilityCalculatorMinimal.readInput: different rc passed than rentabilityCalculatorMinimal. The other ptrentability is causing that.'
						});
						return;
					}
					readInput();
				};
				// define the function to read input from gui to rentability calculator
				rentabilityCalculatorMinimal.writeOutput = function (rc) {
					if (rc !== rentabilityCalculatorMinimal) {
						ptClientErrorLog({
							message: 'rentabilityCalculatorMinimal.readInput: different rc passed than rentabilityCalculatorMinimal. The other ptrentability is causing that.'
						});
						return;
					}
					writeOutput();
				};
				// and update the GUI
				update();
				return true;
			}
			return false;
		}

		/**
		 * find a HTML node within the root of this .roi-calculator-snippet
		 * @param sel css selector
		 * @returns {*}
		 */
		function el(sel) {
			return root.querySelector(sel);
		}

		/**
		 * Take the results after an update() and build the URL Parameters to attach to
		 * the ROI-Calc URL to pass the currently entered values
		 * @returns {URLSearchParams} , use toString()
		 */
		function getParamsForLink() {
			var params = new URLSearchParams();
			params.set('routePlannerActive', rentabilityCalculatorMinimal.routePlannerActive ? 1 : 0);
			params.set('territoryOptimizationActive', rentabilityCalculatorMinimal.territoryOptimizationActive ? 1 : 0);
			params.set('industry', rentabilityCalculatorMinimal.industry);
			params.set('usersField', rentabilityCalculatorMinimal.usersField);
			params.set('usersManagement', rentabilityCalculatorMinimal.usersManagement);
			return params;
		}

		/**
		 * build the link for the buttons to the full ROI
		 * @returns {string} the link, its relative to the web root
		 */
		function buildLink() {
			var params = getParamsForLink().toString();
			return '/return-on-investment/' + pGetLanguage() + (params ? '?' + params : '');
		}

		/**
		 * Read the input values,
		 * this is called by priceCalcRoiMinimal, see ptShopCurrencyLoadedUpdatePricingMinimal()
		 */
		function readInput() {
			// Note: validity of the integer and possible correction happens within RentabilityCalculator.update()
			rentabilityCalculatorMinimal.territoryOptimizationActive = toCheckbox.checked;
			rentabilityCalculatorMinimal.routePlannerActive = rpCheckbox.checked;

			// Field users are always relevant
			rentabilityCalculatorMinimal.usersField = parseInt(usersFieldInput.value, 10) || 1;

			// Management users are only relevant when Territory Optimization is active
			rentabilityCalculatorMinimal.usersManagement = rentabilityCalculatorMinimal.territoryOptimizationActive ?
				// territoryOptimizationActive?
				(parseInt(usersManagementInput.value, 10) || 1) :
				// not TO
				0;
			rentabilityCalculatorMinimal.industry = industryInput.value;
		}

		/**
		 * Write the calculated values into the gui
		 * This also may change the input in cases when RentabilityCalculator cleaned input and modified it.
		 * this is called by priceCalcRoiMinimal, see ptShopCurrencyLoadedUpdatePricingMinimal()
		 */
		function writeOutput() {
			// Show/hide management users and enforce the minimums. The focus guard
			// (activeElement check) keeps us from overwriting the field while the
			// user is actively typing in it.
			if (mgmtContainer) {
				mgmtContainer.style.display = rentabilityCalculatorMinimal.territoryOptimizationActive ? 'block' : 'none';
			}
			
			rpCheckbox.checked = rentabilityCalculatorMinimal.routePlannerActive;
			toCheckbox.checked = rentabilityCalculatorMinimal.territoryOptimizationActive;
			
			usersFieldInput.value = rentabilityCalculatorMinimal.usersField;
			usersManagementInput.value = rentabilityCalculatorMinimal.usersManagement;
					
			resultElem.innerHTML = ptNumber.sprintNumber(
				rentabilityCalculatorMinimal.additionalTotalRevenueField,
				// no decimals
				0,
				// currency
				true
			);
			const updatedLink = buildLink();
			if (submitBtn) submitBtn.href = updatedLink;
			if (submitBigBtn) submitBigBtn.href = updatedLink;

		}

		/**
		 * Call this after user input changed
		 * Read input from gui
		 * calculate mini-roi
		 * Render it
		 */
		function update() {
			if (rentabilityCalculatorMinimal)
				rentabilityCalculatorMinimal.update();
		}

		// usersField/usersManagement accept positive integers only -> strip any non-digit as it is typed
		// or pasted (A-Z etc. cannot be entered). Bound before the update listener below so the value is
		// already clean when update() reads it. The min (>=1, or >=2 when TO active) is enforced on blur.
		['#mroi_usersField', '#mroi_usersManagement'].forEach(function (sel) {
			var intInput = el(sel);
			if (intInput) {
				intInput.addEventListener('input', function () {
					var cleaned = intInput.value.replace(/[^0-9]/g, '');
					if (cleaned !== intInput.value) intInput.value = cleaned;
				});
			}
		});

		var inputs = root.querySelectorAll('.rc-update-input, .rc-update-change');
		inputs.forEach(function (input) {
			input.addEventListener('input', update);
			input.addEventListener('change', update);
			if (input.classList.contains('rc-update-input')) {
				input.addEventListener('blur', function () {
					var toActive = el('#mroi_to').checked;
					if (input.id === 'mroi_usersField') {
						// always at least 1, at least 2 whenever Territory Optimization is active ('to' or 'rpto')
						var min = toActive ? 2 : 1;
						if (input.value === '' || parseInt(input.value) < min) {
							input.value = min;
							update();
						}
					} else if (input.id === 'mroi_usersManagement' && toActive) {
						if (input.value === '' || parseInt(input.value) < 1) {
							input.value = 1;
							update();
						}
					}
				});
			}
		});

		// Initial update
		update();
	}

	function initAll() {
		var roots = document.querySelectorAll('.roi-calculator-snippet');
		for (var i = 0; i < roots.length; i++) {
			RoiMinimal(roots[i]);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}
})();
